import { AsyncPipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, output, inject, input } from '@angular/core';

import { Store } from '@ngrx/store';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  COMPANY_INFO,
} from '@fitness-force/state';
import { DialogModule } from 'primeng/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-help-support',
  templateUrl: './helpsupport.component.html',
  styleUrls: ['./helpsupport.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    HttpClientModule,
    DialogModule,
    AvatarModule,
    TranslateModule,
    AsyncPipe
],
})
export class HelpsupportComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  translate = inject(TranslateService);

  readonly visibility = input(false);
  readonly closeDialog = output<boolean>();
  public companyInfoDetail$!: Observable<any>;
  companyDetails: any;
  machineDetails: any = { browser: '', 'browser-version': '' };
  IPAddress = '';
  currentLocation!: any;

  ngOnInit(): void {
    this.componentInit();
  }
  
  closeDialogEvent() {
    this.closeDialog.emit(true);
  }

  componentInit() {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.companyDetails = responseData;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }


  ngOnDestroy(): void {
    this.closeDialog.emit(true);
  }
}

export function FactoryHttpLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader();
}
